import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 0DB69F3A-8C9B-48D0-8D37-5A1CF6B03B68
 * name bed-queen
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-queen.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedQueenIcon = createSvgIcon(<><path d="M19 10V7A2 2 0 0 0 17 5H7A2 2 0 0 0 5 7V10A2 2 0 0 0 3 12V17H4.33L5 19H6L6.67 17H17.33L18 19H19L19.67 17H21V12A2 2 0 0 0 19 10M17 10H7V7H17Z" /></>, 'BedQueenIcon');
export default BedQueenIcon